import React from 'react';
import PropTypes from 'prop-types';
import ReportBox from '../ReportBox';
import Money from '../../../../common/money';

const GiftCardsSold = ({ giftCardsSoldGross, giftCardsTotalCollected }) => (
  <ReportBox title="Gift Cards Sold">
    <div className="u-text-center u-ph+">
      <div className="c-report-stat c-report-stat--large u-mt+ u-mb--">
        <Money automationId="text:giftCardsSoldGrossAmount">{giftCardsSoldGross}</Money>
      </div>
      <div className="c-report-label u-mb+">Gift Cards Sold (Gross)</div>
      <div className="c-horizontal-divider" />
      <div className="c-report-stat u-mt+ u-mb-">
        <Money automationId="text:giftCardsTotalCollectedAmount">{giftCardsTotalCollected}</Money>
      </div>
      <div className="c-report-label">Total Collected</div>
    </div>
  </ReportBox>
);

GiftCardsSold.propTypes = {
  giftCardsSoldGross: PropTypes.number.isRequired,
  giftCardsTotalCollected: PropTypes.number.isRequired,
};

GiftCardsSold.defaultProps = {};

export default GiftCardsSold;
